module.exports = __WEBPACK_EXTERNAL_MODULE_33__;


//////////////////
// WEBPACK FOOTER
// external {"root":"React","commonjs2":"react","commonjs":"react","amd":"react"}
// module id = 33
// module chunks = 0